"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORBS_MAIN_NET_CONTRACT_ADDRESSES = void 0;
exports.ORBS_MAIN_NET_CONTRACT_ADDRESSES = {
    ercToken: '0xff56Cc6b1E6dEd347aA0B7676C85AB0B3D08B0FA',
    stakingRewardsContract: '0xB5303c22396333D9D27Dc45bDcC8E7Fc502b4B32',
    staking: '0x01D59Af68E2dcb44e04C50e05F62E7043F2656C3',
    monthlySubscriptionPlanContract: '0xADAdC1f110f7D2f8645d3A4EAC62E7F053a33f1F',
    subscriptionsContract: '0xD11EFC10cf3A54B12e3F04143070BE3865E7Bb8E',
    guardiansContract: '0xce97f8c79228c53b8b9ad86800a493d1e7e5d1e3',
    committeeService: '0x1a4c7891d2d04b2cd413b98bc3283c8d992f5fa7',
    delegationsService: '0xB97178870F39d4389210086E4BcaccACD715c71d',
};
//# sourceMappingURL=mainnetAddresses.js.map